import clsx from 'clsx';
import { EntityHistoryFieldChangeDto } from '../entity-history-timeline.types';
import { useEntityHistoryChangeStyles } from './entity-history-timeline-change.styles';

function formatValue(value: unknown): string {
  if (value === undefined || value === null) return '';
  if (typeof value === 'string') return value || '(empty)';
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  if (Array.isArray(value)) return value.length === 0 ? '(empty)' : value.map(formatValue).join(', ');
  try {
    return JSON.stringify(value) || '(empty)';
  } catch {
    return '(empty)';
  }
}

export function EntityHistoryTimelineChange({ change }: { change: EntityHistoryFieldChangeDto }) {
  const classes = useEntityHistoryChangeStyles();

  const typeClassMap: Record<string, string> = {
    added: classes.typeAdded,
    deleted: classes.typeDeleted,
    updated: classes.typeUpdated
  };

  const typeClass = typeClassMap[change.type] || classes.typeUpdated;

  return (
    <div className={classes.wrapper}>
      <span className={classes.label}>{change.label}</span>{' '}
      <span className={clsx(classes.type, typeClass)}>{change.type}</span>{' '}
      <span className={classes.values}>
        {change.previousValue !== undefined && (
          <span className={classes.previousValue}>{formatValue(change.previousValue)}</span>
        )}
        {change.previousValue !== undefined && change.newValue !== undefined && (
          <>
            {' '}
            <span className={classes.arrow}>&rarr;</span>
            &nbsp;
          </>
        )}
        {change.newValue !== undefined && <span className={classes.newValue}>{formatValue(change.newValue)}</span>}
      </span>
    </div>
  );
}
